class HiyoMarqueeText extends HTMLElement {
  #resizeObserver;

  connectedCallback() {
    this.#resizeObserver?.disconnect();

    if ('ResizeObserver' in window) {
      this.#resizeObserver = new ResizeObserver((entries) => {
        this.#calculateDuration(entries[0]?.contentRect.width);
      });
      this.#resizeObserver.observe(this);
    } else {
      this.#calculateDuration();
    }

  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
  }

  #calculateDuration(measuredWidth) {
    const contentWidth = measuredWidth || this.getBoundingClientRect().width;
    const firstCopy = this.querySelector('.hiyo-scrolling-text__text');

    if (!firstCopy || contentWidth <= 0 || firstCopy.clientWidth <= 0) return;

    const scrollingSpeed = Number.parseFloat(
      this.getAttribute('scrolling-speed') || '5'
    );
    const slowFactor =
      1 + (Math.min(1600, contentWidth) - 375) / 1225;
    const duration =
      (scrollingSpeed * slowFactor * firstCopy.clientWidth) / contentWidth;

    this.style.setProperty(
      '--marquee-animation-duration',
      `${Math.max(0.1, duration).toFixed(3)}s`
    );
  }
}

if (!customElements.get('marquee-text')) {
  customElements.define('marquee-text', HiyoMarqueeText);
}
